import { call, put, takeLatest } from 'typed-redux-saga'
import { errorHandler } from 'Modules'
import { preloginApi, PreloginNS, preloginSlice } from 'Pages/prelogin'
import { FormNames } from 'Constants/FormNames'
import { partnersSlice } from 'Pages/partner'

function* updatePartnerSaga(action: PreloginNS.UpdatePartner) {
	try {
		const { id, data, callback } = action.payload
		yield* put(preloginSlice.actions.setIsLoading(true))
		const res = yield* call(preloginApi.updatePartner, id, data)
		yield* put(preloginSlice.actions.setPartner(res))
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error, FormNames.PARTNER_PROFILE.PRELOGIN)
	} finally {
		yield* put(preloginSlice.actions.setIsLoading(false))
	}
}

function* getPartnerSaga(action: PreloginNS.GetPartner) {
	try {
		yield* put(preloginSlice.actions.setIsLoading(true))
		const res = yield* call(preloginApi.getPartner, action.payload)
		yield* put(partnersSlice.actions.getDocuments(action.payload))
		yield* put(preloginSlice.actions.setPartner(res))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(preloginSlice.actions.setIsLoading(false))
	}
}

function* deleteDocumentSaga(action: PreloginNS.DeleteDocument) {
	try {
		const { id, partnerId } = action.payload
		yield* put(preloginSlice.actions.setIsLoading(true))
		yield* call(preloginApi.deleteDocument, id, partnerId)
		yield* put(preloginSlice.actions.getPartner(partnerId))
	} catch (error) {
		yield* call(errorHandler, error, FormNames.PARTNER_PROFILE.PRELOGIN)
		yield* put(preloginSlice.actions.setIsLoading(false))
	}
}

function* createDocumentSaga(action: PreloginNS.CreateDocument) {
	try {
		const { data } = action.payload
		yield* put(preloginSlice.actions.setIsLoading(true))
		yield* call(preloginApi.createDocument, data)
		yield* put(preloginSlice.actions.getPartner(data?.partner_id))
	} catch (error) {
		yield* call(errorHandler, error, FormNames.PARTNER_PROFILE.PRELOGIN)
		yield* put(preloginSlice.actions.setIsLoading(false))
	}
}

function* setStatusSaga(action: PreloginNS.SetStatus) {
	try {
		const { id, status, callback } = action.payload
		yield* put(preloginSlice.actions.setIsLoading(true))
		yield* call(preloginApi.setStatus, id, status)
		yield* put(preloginSlice.actions.getPartner(id))
		callback?.()
	} catch (error) {
		yield* put(preloginSlice.actions.setIsLoading(false))
		yield* call(errorHandler, error, FormNames.PARTNER_PROFILE.PRELOGIN)
	}
}

export function* preloginSaga() {
	yield* takeLatest(preloginSlice.actions.updatePartner, updatePartnerSaga)
	yield* takeLatest(preloginSlice.actions.getPartner, getPartnerSaga)
	yield* takeLatest(preloginSlice.actions.deleteDocument, deleteDocumentSaga)
	yield* takeLatest(preloginSlice.actions.createDocument, createDocumentSaga)
	yield* takeLatest(preloginSlice.actions.setStatus, setStatusSaga)
}
